var _rect, _title, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "backgroundrect",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "none",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    className: "currentLayer",
    style: {}
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "search",
    d: "M27.207,24.37866,20.6106,17.78235a9.03069,9.03069,0,1,0-2.82825,2.82825L24.37878,27.207a1,1,0,0,0,1.41425,0l1.414-1.41418A1,1,0,0,0,27.207,24.37866ZM13,19a6,6,0,1,1,6-6A6.00657,6.00657,0,0,1,13,19Z",
    className: "selected",
    fillOpacity: 1,
    fill: "#8dc63f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchGreen);
export default __webpack_public_path__ + "static/media/search_green.e110b0b95faa5694363c78ca3186a8a2.svg";
export { ForwardRef as ReactComponent };